export enum FormSection {
    Personal = 'personal',
    Professional = 'professional'
};
